import toast from "react-hot-toast";
import BasePage from "../../../../base/BasePage";
import dialog from "../../../../components/Modal/dialog";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Progress from "../../../../components/Progress";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import createPromise from "../../../../utils/createPromise";

import withRouter from "../../../../utils/withRouter";
import ChangePasswordModal from "./components/ChangePasswordModal";
import Info from "./components/Info";
import UserImage from "./components/UserImage";
import { signInUseCase } from "../../../../usecases/user";

class ProfileViewPage extends BasePage {
  state = { userInfo: {}, changePassword: {}, loading: false };

  componentDidMount() {
    this.getUserInfo();
  }

  async getUserInfo() {
    const { id } = this.getCurrentUser();
    try {
      this.setState({ loading: true });
      const [user] = await findObjectUseCase().execute("users", {
        where: { id },
        include: ["affiliate", "branch"],
      });
      this.setState({ userInfo: user });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleEditProfile() {
    const { id } = this.getCurrentUser();
    this.navigateTo(id);
  }

  async handleChangePassword() {
    await this.showChangePasswordModal();

    const { oldPassword, newPassword, confirmNewPassword } =
      this.state.changePassword;

    if (newPassword !== confirmNewPassword) {
      toast.error("Password and confirm password must be the same");
      return;
    }

    const user = this.getCurrentUser();

    // Wrap the operations in a single promise and use toast.promise
    const changePasswordPromise = (async () => {
      // CHECK IF OLD PASSWORD IS CORRECT BY SIGNING IN
      await signInUseCase().execute(
        {
          username: user.username,
          password: oldPassword,
        },
        { token: false }
      );

      // CHANGE PASSWORD
      await upsertUseCase().execute("users", {
        ...user,
        password: newPassword,
      });
    })();

    toast.promise(
      changePasswordPromise,
      {
        loading: "Changing password...",
        success: "Successfully changed password",
        error: "Failed to change password",
      },
      { position: "top-right" }
    );

    try {
      await changePasswordPromise;
    } catch (error) {
      console.log(error);
    }
  }

  showChangePasswordModal() {
    const promise = createPromise();
    dialog.fire({
      html: <ChangePasswordModal onChange={this.onChange.bind(this)} />,
      positiveButton: "Submit",
      negativeButton: "Cancel",
      onPositiveClick: () => {
        promise.resolve();
      },
      onNegativeClick: () => {
        promise.reject();
      },
    });

    return promise;
  }

  onChange(value, field) {
    const object = this.state.changePassword;
    object[field] = value;
    this.setState({ changePassword: object });
  }

  render() {
    if (this.state.loading) return <Progress />;

    const {
      firstName,
      middleName,
      lastName,
      image,
      username,
      position,
      department,
      telephoneNumber,
      mobileNumber,
      faxNumber,
      email,
      alternateEmail,
      alternateEmail2,
      affiliate,
      branch,
    } = this.state.userInfo;

    const personalDetails = [
      {
        title: "First Name",
        value: firstName,
      },
      {
        title: "Middle Name",
        value: middleName,
      },
      {
        title: "Last Name",
        value: lastName,
      },
      {
        title: "Position",
        value: position,
      },
      {
        title: "Department",
        value: department,
      },
      {
        title: "Telephone Number",
        value: telephoneNumber,
      },
      {
        title: "Mobile Number",
        value: mobileNumber,
      },
      {
        title: "Fax Number",
        value: faxNumber,
      },
      {
        title: "Email",
        value: email,
      },
      {
        title: "(1) Alternate Email",
        value: alternateEmail || "None",
      },
      {
        title: "(2) Alternate Email",
        value: alternateEmail2 || "None",
      },
    ];

    return (
      <PageContainer
        title="My Profile"
        rightButtonLabel="Edit Profile"
        rightButtonHandler={this.handleEditProfile.bind(this)}
      >
        <div className="row mt-4">
          <div className="col">
            <div className="d-flex flex-column gap-4">
              <UserImage url={image} />
              <Info
                sectionTitle="LOGIN INFORMATION"
                data={[
                  { title: "Username", value: username },
                  { title: "Password", value: "********" },
                ]}
              />
              <button
                className="btn btn-primary"
                onClick={this.handleChangePassword.bind(this)}
                style={{ fontSize: ".875rem", width: "fit-content" }}
              >
                Change Password
              </button>
            </div>
          </div>
          <div className="col">
            <Info sectionTitle="PERSONAL DETAILS" data={personalDetails} />
          </div>
          <div className="col">
            <Info
              sectionTitle="AFFILIATE & BRANCH"
              data={[
                {
                  title: "Affiliate",
                  value: affiliate?.code ? affiliate?.code : affiliate?.id,
                },
                {
                  title: "Branch",
                  value: branch?.code ? branch?.code : branch?.id,
                },
              ]}
            />
          </div>
        </div>
      </PageContainer>
    );
  }
}

export default withRouter(ProfileViewPage);
